import type { ChangeEvent } from 'react';
import { forwardRef } from 'react';

import useUuid from 'pkg/hooks/useUuid';

import MaterialSymbol from 'components/material-symbols';

import * as Input from 'components/form/inputs';

import * as css from './styles.css';

interface Props {
	items: string[];
	value: string;
	onChange: (value: string | number) => void;
	onBlur?: (value: string) => void;
	onClick?: () => void;
}

/**
 * SearchableList component
 *
 * A search input with an integrated datalist
 */

export const SearchableList = forwardRef<HTMLInputElement, Props>(
	({ items, value, onChange, onBlur, onClick }, ref) => {
		const listId = useUuid();

		const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
			onChange(event.target.value);

		const handleBlur = (event: ChangeEvent<HTMLInputElement>) =>
			onBlur(event.target.value);

		return (
			<div className={css.searchContainer}>
				<Input.Field
					value={value}
					onChange={handleChange}
					onBlur={handleBlur}
					onClick={onClick}
					list={listId}
					ref={ref}>
					<Input.Prefix>
						<MaterialSymbol variant="search" />
					</Input.Prefix>
				</Input.Field>

				<datalist id={listId}>
					{items.map((item, index) => (
						<option key={index} value={item} />
					))}
				</datalist>
			</div>
		);
	}
);
